module.exports = __webpack_public_path__ + "media/images/turbochargers/02-15dddbdc6797cb14f5e14a3968c15abf.png";